import { useEffect, useState } from "react"

export function useFileUrl(file: File): string | undefined {
	const [url, setUrl] = useState<string>()

	useEffect(() => {
		const url = URL.createObjectURL(file)
		setUrl(url)

		return () => {
			URL.revokeObjectURL(url)
		}
	}, [file])

	return url
}
